import { FC } from "react";
import classNames from "classnames";
import { useSetAtom } from "jotai";

import { Button, EButtonVariant } from "components/Button/Button";
import { DialogContent } from "components/DialogContent/DialogContent";
import { SemiBoldText } from "components/SemiBoldText/SemiBoldText";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";

import { setModalCloseAtom } from "../../atoms/modalAtom/modalAtom";

import styles from "./styles.module.css";

export type InfoModalProps = {
  title: string;
  onOkClick?: () => void;
  buttonText?: string;
  atomToOpen?: any;
  setAtomClose?: any;
  height?: number;
};

export const InfoModal: FC<InfoModalProps> = ({
  title,
  onOkClick,
  buttonText = "Ок",
  setAtomClose = setModalCloseAtom,
  height,
}): JSX.Element => {
  const closeModal = useSetAtom(setAtomClose);

  const handleClick = () => {
    if (typeof onOkClick === "function") {
      onOkClick();
    } else {
      closeModal();
    }
  };

  return (
    <DialogContent
      className={classNames(styles.dialog, "flex items-center flex-col")}
      style={{ height: height ? `${height}px` : undefined }}
      setAtomClose={setAtomClose}
    >
      <SemiBoldText className="mt-7 mb-6 flex justify-center items-center text-center">
        {title}
      </SemiBoldText>
      <VerticalSpace size={36} />
      <div className="flex flex-row">
        <Button onClick={handleClick} variant={EButtonVariant.SECONDARY}>
          {buttonText}
        </Button>
      </div>
    </DialogContent>
  );
};
